import { ReactComponent as LogoWhite } from "./svg/educa.svg";

import authBg from "./jpg/auth-bg.jpg";
import educabanner from "./jpg/pruebanueva.jpg";
import icoed360 from "./png/icoeduca360.png";
import icoedver from "./png/icoeducaverse.png";
import icoedujob from "./png/icoeducajob.png";
import logoE360 from "./png/Educa360Logo.png";
import logoRevi from "./png/logorevi.png";
import partnerAvatar from "./png/chatbot_avatar/partnerAvatar.png";
import studentAvatar from "./png/chatbot_avatar/studentAvatar.png";
import teacherAvatar from "./png/chatbot_avatar/teacherAvatar.png";
import institutionAvatar from "./png/chatbot_avatar/institutionAvatar.png";
import revi01Png from "./png/reviImg/revi01.png";
import revi02Png from "./png/reviImg/revi02.png";
import revi03Png from "./png/reviImg/revi03.png";
import revi05Png from "./png/reviImg/revi05.png";
import plataformaPng from "./png/reviImg/plataforma.png";
import plataforma01Png from "./png/reviImg/plataforma01.png";
import plataforma02Png from "./png/reviImg/plataforma02.png";
import plataforma03Png from "./png/reviImg/plataforma03.png";
import footertvPng from "./png/reviImg/footertv.png";
import scene01Png from "./png/reviImg/scene01.png";
import scene02Png from "./png/reviImg/scene02.png";
import document from "./document/REVI_Dossier.pdf";

const Icon = {
  LogoWhite,
};
const logoEduca = {
  logoE360,
};
const LogoRevi = {
  logoRevi,
};
const image = {
  authBg,
  icoed360,
  icoedver,
  icoedujob,
  partnerAvatar,
  studentAvatar,
  teacherAvatar,
  institutionAvatar,
  educabanner,
  revi01Png,
  revi02Png,
  revi03Png,
  revi05Png,
  plataformaPng,
  plataforma01Png,
  plataforma02Png,
  plataforma03Png,
  footertvPng,
  scene01Png,
  scene02Png,
  document,
};

export { Icon, image, logoEduca, LogoRevi };
